import { render, staticRenderFns } from "./workflowDisclaimer.vue?vue&type=template&id=37be5936&"
import script from "./workflowDisclaimer.vue?vue&type=script&lang=js&"
export * from "./workflowDisclaimer.vue?vue&type=script&lang=js&"
import style0 from "./workflowDisclaimer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports